module.exports = __webpack_public_path__ + "06_mustache_brown.7824ecae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/06_mustache_brown.png
// module id = WG/j
// module chunks = 0